import { forwardRef } from "react";
import {
	Link,
	type LinkProps,
	NavLink,
	type NavLinkProps,
	type To,
} from "react-router-dom";
import { useLocalizedHref } from "./use-localized-href";

const localizeTo = (to: To, localize: (path: string) => string): To => {
	if (typeof to === "string") return localize(to);
	if (to.pathname) return { ...to, pathname: localize(to.pathname) };
	return to;
};

const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
	({ to, ...rest }, ref) => {
		const localizedHref = useLocalizedHref();
		return <Link ref={ref} to={localizeTo(to, localizedHref)} {...rest} />;
	},
);
LocalizedLink.displayName = "LocalizedLink";

const LocalizedNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
	({ to, ...rest }, ref) => {
		const localizedHref = useLocalizedHref();
		return <NavLink ref={ref} to={localizeTo(to, localizedHref)} {...rest} />;
	},
);
LocalizedNavLink.displayName = "LocalizedNavLink";

export { LocalizedLink, LocalizedNavLink };
